import attachMessageListener from './window-message-listener'

export default attachMessageListener
